<template>
    <div class="step-bar">
        <div
            class="step-item"
            v-for="n in 4"
            :key="n"
            @click="handleStepClick(n)"
            :style="{ cursor: step >= n ? 'pointer' : 'not-allowed' }"
        >
            <!-- 步骤图片 -->
            <div class="circle-img">
                <img :src="require(`@/assets/images/home/step_${n}${step >= n ? '_active' : ''}.png`)" class="step-icon" />
            </div>
            <!-- 竖线和圆点，active时为蓝色，否则为灰色 -->
            <div class="vertical-wrap">
                <div :class="['vertical-line', { active: step >= n }]" />
                <div :class="['dot', { active: step >= n }]" />
            </div>
            <!-- 横线（除最后一个步骤外）-->
            <div v-if="n < 5" class="step-horizontal"></div>
            <!-- 步骤文字和数字 -->
            <div :class="['step-label', { active: step >= n }]">
                <span :class="['step-num', { active: step >= n }]">{{ n }}</span>
                <span :class="['step-text', { active: step >= n }]">
                    {{ stepTexts[n - 1] }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'step',
    props: {
        step: {
            type: Number,
            default: 1,
            require: true
        }
    },
    data() {
        return {
            stepTexts: ['选购商品', '填写收货地址', '选填发票信息', '支付购买'],
            // 步骤对应的路由名或path，请根据实际情况修改
            stepRoutes: [
                { name: 'index' }, // 第一步
                { name: 'receiving-address' }, // 第二步
                { name: 'Invoice' }, // 第三步
                { name: 'payment' } // 第四步
            ]
        }
    },
    methods: {
        handleStepClick(n) {
            // 只允许跳转到已完成或当前步骤 不允许已创建的订单返回
            if (this.step >= n && this.step !=4) {
                const route = this.stepRoutes[n - 1];
                // 获取当前路由参数
                const { params, query } = this.$route;
                // 跳转并保留参数
                this.$router.push({
                    ...route,
                    params: { ...params },
                    query: { ...query }
                });
            }
        }
    }
}
</script>

<style scoped>
.step-bar {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin: 0px auto 40px auto;
    /* width: var(--main-width); */
    width: 1000px;
    position: relative;
}
.step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex: 1;
    min-width: 180px;
}
.circle-img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    z-index: 2;
}
.step-icon {
    width: 55px;
    height: 55px;
}
.vertical-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 32px;
    margin-top:-14px;
    margin-bottom: 5px;
}
.vertical-line {
    width: 2px;
    height: 22px;
    background: #BFBFC1;
}
.vertical-line.active {
    background: #2866D5;
}
.dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid #BFBFC1;
    margin-top: -2px;
    z-index: 2;
}
.dot.active {
    border: 2px solid #2866D5;
}
.step-horizontal {
    position: absolute;
    top: 91px;
    width:100%;
    height: 2px;
    background: #2866D5;
    z-index: 1;
    /* transform: translateX(50%); */
}
.step-label {
    display: flex;
    align-items: center;
    /* margin-top: 6px; */
    background: #BFBFC1;
    border-radius: 18px;
    /* padding: 2px 18px 2px 0px; */
    color: #bdbdbd;
    font-size: 20px;
    font-weight: 500;
    transition: all 0.2s;
    width: 150px;
}
.step-label.active {
    background: #2866D5;
    color: #fff;
}
.step-num {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid #bdbdbd;
    color: #bdbdbd;
    font-size: 14px;
    /* font-weight: 600; */
    /* margin-right: 8px; */
    transition: all 0.2s;
}
.step-num.active {
    border: 2px solid #2866D5;
    color: #2866D5;
}
.step-text {
    font-size:14px;
    color: #fff;
    transition: all 0.2s;
    width: 102px;
    text-align: center;
}
.step-text.active {
    color: #fff;
}
</style>
